module.exports = __webpack_public_path__ + "static/media/dinner.60301a5c.jpeg";